// Router.js
import { Routes, Route, BrowserRouter } from "react-router-dom";
import adminDashboardRoutes from "./routes";
import AuthWrapper from "./components/pages/authentication/AuthWrapper";
import { useAppDispatch } from "./hooks/redux/hooks";
import { useEffect } from "react";
import { setSearchValue } from "./store/searchValue/searchValueSlice";
function Router() {

    const dispatch = useAppDispatch();
    // let currentEndpoint = window.location?.pathname;

    useEffect(() => {
        const clearSearchOnRouteChange = () => {
            dispatch(setSearchValue(""));

        };

        window.addEventListener('popstate', clearSearchOnRouteChange);
        window.addEventListener('pushstate', clearSearchOnRouteChange);

        return () => {
            window.removeEventListener('popstate', clearSearchOnRouteChange);
            window.removeEventListener('pushstate', clearSearchOnRouteChange);
        };
    }, []);
    return (
        <BrowserRouter >
            <Routes>

                {adminDashboardRoutes.map((route, index) => (
                    <Route key={index} path={route.path}
                        element={
                            <AuthWrapper>
                                <route.element />
                            </AuthWrapper>
                        } />
                ))}
            </Routes>
        </BrowserRouter>
    );
}


export default Router;
